export default __webpack_public_path__ + "static/media/BG-gradient.e62f9c86.png";